import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { ThreeDots } from "../../styled/AllImages";

function ActionDropdown({
  itemsList,
  title,
  property,
  onEdit,
  onDelete,
  onStatusChange,
  hashId,
  id,
  ...rest
}) {
  const { t } = useTranslation();
  // Handle dropdown selection
  const handleItemClick = (action) => {
    if (action === "edit") {
      onEdit(hashId, id);
    }
    if (action === "delete") {
      onDelete(id);
    }
    if (action === "SoldOut") {
      onStatusChange(hashId);
    }
  };
  return (
    <DropdownWrapper {...rest}>
      <DropdownButton
        id="dropdown-basic-button"
        title={title}
        className="custom-dropdown"
      >
        
        {itemsList && itemsList.length > 0 && itemsList.map((item, key) => (
          <Dropdown.Item as={Link} key={key} to={item.path} onClick={() => handleItemClick(item.action)}>
            {item.icon && <item.icon className={"mx-2"}/>}
            {item.action === "SoldOut" ? !Number(property?.marked_as_sold) ? t(item.label) : t("MarkAvailable") : t(item?.label)}
            </Dropdown.Item>
        ))}
      </DropdownButton>
    </DropdownWrapper>
  );
}

export default ActionDropdown;

const DropdownWrapper = styled.div`
  .custom-dropdown .btn {
    display: flex;
    align-items: center;
    padding: 0;
    background-color: transparent;
    &,
    &.show,
    &:focus-visible,
    &:focus,
    &:hover,
    &:active {
      border: 0px;
      border-radius: 0;
      padding: 0;
      background-color: none;
      
    }
    
  }
  .dropdown-menu{
    padding-top: 0;
    padding-bottom: 0;
  }
  .custom-dropdown  {
    .dropdown-item {
      text-align: start;
        padding: 10px 16px 8px 16px;
        line-height: 1;
        color: var(--darkGrey);
        font-size: 14px;
    }
    .dropdown-item:not(:last-child){
        border-bottom: 1px solid var(--border);
    }
  }
  &.notifyDropdown .custom-dropdown .btn:after {
    display: none;
  }
  @media (max-width: 767px) {
    .custom-dropdown .btn {
      padding-left: 10px !important;
      padding-right: 10px !important;
    }
  }
  
`;
